module.exports = __webpack_public_path__ + "static/media/javascript_cup.b4d5e3a4.jpg";